import { Button, Flex, Modal } from 'antd';
import { FC, useCallback, useEffect, useState } from 'react';
import { useAppSelector } from 'store/hooks';
import { selectPdfForViewer } from 'store/file/selectors';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Loading } from 'components/ui';
import { instance } from 'utils/api';

const PdfViewer: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [file, setFile] = useState('');
  const url = useAppSelector(selectPdfForViewer(id));
  const { t } = useTranslation();

  const showError = useCallback(() => {
    Modal.error({
      title: t('messages.error'),
      content: t('messages.file_not_found'),
      footer: (
        <Flex style={{ marginTop: 16 }} justify="flex-end" gap={4}>
          <Button
            onClick={() => {
              Modal.destroyAll();
              navigate('/');
            }}
          >
            {t('common.cancel')}
          </Button>
          <Button type="primary" onClick={() => window.location.reload()}>
            {t('common.try_again')}
          </Button>
        </Flex>
      )
    });
  }, [navigate, t]);

  useEffect(() => {
    (async () => {
      try {
        if (!url) {
          throw new Error();
        }

        const res = await instance.get(url, {
          responseType: 'blob'
        });

        const dataUrl = URL.createObjectURL(res.data);

        setFile(dataUrl);
      } catch {
        showError();
      }
    })();
  }, [showError, url]);

  if (!file) {
    return <Loading />;
  }

  return (
    <iframe
      src={file}
      style={{ width: '100vw', height: '100vh', border: 'none' }}
    />
  );
};

export default PdfViewer;
